import { render, staticRenderFns } from "./TencenVideo.vue?vue&type=template&id=8e4b62a8"
import script from "./TencenVideo.vue?vue&type=script&lang=js"
export * from "./TencenVideo.vue?vue&type=script&lang=js"
import style0 from "./TencenVideo.vue?vue&type=style&index=0&id=8e4b62a8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e4b62a8')) {
      api.createRecord('8e4b62a8', component.options)
    } else {
      api.reload('8e4b62a8', component.options)
    }
    module.hot.accept("./TencenVideo.vue?vue&type=template&id=8e4b62a8", function () {
      api.rerender('8e4b62a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TencenVideo.vue"
export default component.exports